import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "text-lg-h6 px-4 py-2 bg-indigo-lighten-2 d-flex justify-space-between align-center" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "ml-3"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "ml-3"
}

import { ref, computed, onMounted, watch, reactive } from 'vue'
import { ApiMap } from '@/api/type'
import { game } from '@/api'
import { useApi } from '@/api/handler'
import DynamicForm from '../DynamicForm.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TileRank',
  props: {
    data: {},
    maxHeight: {},
    showChange: { type: Boolean },
    mode: {},
    enableEdit: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const enableEdit = computed(() => props.enableEdit ?? true)

const emits = __emit

const internalMode = ref(true) // 默认展示 team
const isLocked = computed(() => props.mode !== undefined)
const computedMode = computed(() =>
  props.mode === 'team' ? true :
    props.mode === 'student' ? false :
      internalMode.value
)

const tileRank = ref<ApiMap['/game/rank/team/:id']['resp']>([])
const individualRank = ref<ApiMap['/game/rank/student/:id']['resp']>([])
const GameStatus = ref<ApiMap['/game/status/:id']['resp'] | null>(null)

const rankColors = ['amber darken-2', 'blue-grey lighten-1', 'deep-orange lighten-1']

const sortedTeamData = computed(() =>
  [...tileRank.value].sort((a, b) =>
    b.totalTile !== a.totalTile ? b.totalTile - a.totalTile : b.totalScore - a.totalScore
  )
)

const sortedIndividualData = computed(() =>
  [...individualRank.value].sort((a, b) => b.individualScore - a.individualScore)
)

const submitObject = reactive<{ type: number, showOverlay: boolean, data: any }>({
  type: 2,
  showOverlay: false,
  data: {}
})

function handleRowClick(item: any, index: number) {
  emits('click', { mode: 'student', item, index })
  if (!enableEdit.value) return
  if (!GameStatus.value) return;
  submitObject.data = {
    type: submitObject.type,
    stage: 1,
    id: item.studentId,
    gameId: GameStatus.value.id,
    num: 0,
    comment: ""
  }
  submitObject.showOverlay = true
}

function useSubmitScoreEditor(data: ApiMap['/game/score/update']['req']) {
  console.log(data)
  useApi({
    api: game.SubmitScoreEditor(data),
    Finally: () => { submitObject.showOverlay = false },
    onSuccess: () => {
      submitObject.showOverlay = false
      loadRankData()
    },
    tip: '更改成功'
  })
  console.log(individualRank.value)
}

watch(() => props.data, () => {
  GameStatus.value = props.data ?? null
  loadRankData()
}, { immediate: true })
watch(computedMode, () => loadRankData())

onMounted(() => loadRankData())

function loadRankData() {
  if (!props.data) return
  if (computedMode.value) {
    useApi({
      api: game.TileRank(props.data.id),
      onSuccess: resp => {
        tileRank.value = resp.data as ApiMap['/game/rank/team/:id']['resp']
      }
    })
  } else {
    useApi({
      api: game.IndividualRank(props.data.id),
      onSuccess: resp => {
        individualRank.value = resp.data as ApiMap['/game/rank/student/:id']['resp']
      }
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      rounded: "",
      "max-height": _ctx.maxHeight ?? 400
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(computedMode.value ? '占领格子数排行榜' : '个人积分排行榜'), 1),
          (!isLocked.value && _ctx.showChange)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                size: "small",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (internalMode.value = !internalMode.value)),
                class: "text-caption",
                color: "white",
                variant: "tonal"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" 切换 ")
                ])),
                _: 1,
                __: [3]
              }))
            : _createCommentVNode("", true)
        ]),
        (computedMode.value && tileRank.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "ml-2",
              style: _normalizeStyle(`overflow-y: auto; height: ${_ctx.maxHeight - 50}px`)
            }, [
              _createVNode(_component_v_table, {
                density: "compact",
                class: "rounded"
              }, {
                default: _withCtx(() => [
                  _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "排名"),
                      _createElementVNode("th", null, "组号"),
                      _createElementVNode("th", null, "组长"),
                      _createElementVNode("th", null, "格子数")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedTeamData.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.teamId,
                        onClick: ($event: any) => (emits('click', { mode: 'team', item, index })),
                        style: {"cursor":"pointer"}
                      }, [
                        _createElementVNode("td", null, [
                          (index < 3)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                color: rankColors[index],
                                "text-color": "white",
                                density: "compact",
                                small: "",
                                label: "",
                                class: "font-weight-bold"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 第 " + _toDisplayString(index + 1) + " 名 ", 1)
                                ]),
                                _: 2
                              }, 1032, ["color"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_3, "第 " + _toDisplayString(index + 1) + " 名", 1))
                        ]),
                        _createElementVNode("td", null, "第 " + _toDisplayString(item.teamId) + " 组", 1),
                        _createElementVNode("td", null, _toDisplayString(item.leaderName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.totalTile), 1)
                      ], 8, _hoisted_2))
                    }), 128))
                  ])
                ]),
                _: 1,
                __: [4]
              })
            ], 4))
          : _createCommentVNode("", true),
        (!computedMode.value && individualRank.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "ml-2",
              style: _normalizeStyle(`overflow-y: auto; height: ${_ctx.maxHeight - 50}px`)
            }, [
              _createVNode(_component_v_table, {
                density: "compact",
                class: "rounded"
              }, {
                default: _withCtx(() => [
                  _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "排名"),
                      _createElementVNode("th", null, "姓名"),
                      _createElementVNode("th", null, "学号"),
                      _createElementVNode("th", null, "组号"),
                      _createElementVNode("th", null, "得分")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedIndividualData.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.studentId,
                        onClick: ($event: any) => (handleRowClick(item, index)),
                        style: {"cursor":"pointer"}
                      }, [
                        _createElementVNode("td", null, [
                          (index < 3)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                color: rankColors[index],
                                "text-color": "white",
                                density: "compact",
                                small: "",
                                label: "",
                                class: "font-weight-bold"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 第 " + _toDisplayString(index + 1) + " 名 ", 1)
                                ]),
                                _: 2
                              }, 1032, ["color"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_5, "第 " + _toDisplayString(index + 1) + " 名", 1))
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.studentName), 1),
                        _createElementVNode("td", null, _toDisplayString(item.memberSno), 1),
                        _createElementVNode("td", null, "第 " + _toDisplayString(item.teamId) + " 组", 1),
                        _createElementVNode("td", null, _toDisplayString(item.individualScore), 1)
                      ], 8, _hoisted_4))
                    }), 128))
                  ])
                ]),
                _: 1,
                __: [5]
              })
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["max-height"]),
    _createVNode(_component_v_overlay, {
      modelValue: submitObject.showOverlay,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((submitObject.showOverlay) = $event)),
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        _createVNode(DynamicForm, {
          model: submitObject.data,
          title: "请输入个人积分变更",
          headers: ['', '', '', '', '个人分数变更', '评论'],
          "excluded-keys": ['type', 'stage', 'id', 'gameId'],
          onSubmit: useSubmitScoreEditor,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (submitObject.showOverlay = false))
        }, null, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})